import { GROUP_TYPE_MAT, DEFAULT_DATA_STORAGE_LOCATION } from '../../../constants/groupSchoolFieldOptions';

// Pure builder for the updateMatGroup body — identical field-for-field to what
// EditGroupModal submitted (partial update: only non-empty fields are sent, and the GUID
// only for MAT groups). Pure so the parity can be asserted in a unit test. Archive state is
// deliberately absent: it changes only through the dedicated archive/unarchive actions.
export const buildUpdateMatGroupPayload = (values, groupId) => {
  const data = { id: groupId };

  if (values.name && values.name.trim()) data.name = values.name.trim();
  if (values.groupName && values.groupName.trim()) data.groupName = values.groupName.trim();
  if (values.groupType && values.groupType.trim()) data.groupType = values.groupType.trim();
  if (values.groupType === GROUP_TYPE_MAT && values.matGroupUID && values.matGroupUID.trim()) {
    data.matGroupUID = values.matGroupUID.trim();
  }
  if (values.country) data.country = values.country;
  if (values.dataStorageLocation) data.dataStorageLocation = values.dataStorageLocation;
  if (values.customerType) data.customerType = values.customerType;
  if (values.isDisplayMatHeatMap !== undefined) data.isDisplayMatHeatMap = values.isDisplayMatHeatMap;
  if (values.isAnnonymised !== undefined) data.isAnnonymised = values.isAnnonymised;
  if (values.isTestAccount !== undefined) data.isTestAccount = values.isTestAccount;

  return data;
};

// The group entity comes back PascalCase or camelCase depending on the endpoint; read
// group-level fields tolerantly for the edit form's initial values.
export const groupInitialValues = (group = {}) => {
  const findGroupType = (data) => {
    const paths = [
      data.GroupType, data.groupType,
      data.MatGroup?.GroupType, data.MatGroup?.groupType,
      data.GroupDirectors?.[0]?.MatGroup?.GroupType, data.GroupDirectors?.[0]?.MatGroup?.groupType,
      data.GroupDirectors?.[0]?.GroupType, data.GroupDirectors?.[0]?.groupType,
    ];
    return paths.find((val) => val !== undefined && val !== null && val !== '') || '';
  };
  const findMatGroupUID = (data) => {
    const paths = [
      data.MatGroupUID, data.matGroupUID,
      data.MatGroup?.MatGroupUID, data.MatGroup?.matGroupUID,
      data.GroupDirectors?.[0]?.MatGroup?.MatGroupUID, data.GroupDirectors?.[0]?.MatGroup?.matGroupUID,
    ];
    return paths.find((val) => val !== undefined && val !== null && val !== '') || '';
  };

  return {
    id: group.Id ?? group.id ?? 0,
    name: group.Name || group.name || '',
    groupName: group.GroupName || group.groupName || group.Name || group.name || '',
    groupType: findGroupType(group),
    matGroupUID: findMatGroupUID(group),
    country: group.Country || group.country || '',
    dataStorageLocation: group.DataStorageLocation || group.dataStorageLocation || DEFAULT_DATA_STORAGE_LOCATION,
    customerType: group.CustomerType || group.customerType || '',
    isDisplayMatHeatMap: group.IsDisplayMatHeatMap || group.isDisplayMatHeatMap || false,
    isAnnonymised: group.IsAnnonymised || group.isAnnonymised || false,
    isTestAccount: group.IsTestAccount || group.isTestAccount || false,
  };
};
